import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Building2, Briefcase, TreePine, Cpu } from "lucide-react"

const assetClasses = [
  {
    title: "Real Estate",
    description: "Premium commercial and residential property investments across global markets.",
    aum: "$1.2B",
    icon: Building2,
    performance: "+12.5% YoY"
  },
  {
    title: "Venture Capital",
    description: "Strategic investments in high-growth technology and innovation companies.",
    aum: "$800M",
    icon: Briefcase,
    performance: "+28.3% YoY"
  },
  {
    title: "Sustainable Assets",
    description: "ESG-focused investments in renewable energy and sustainable infrastructure.",
    aum: "$350M",
    icon: TreePine,
    performance: "+15.7% YoY"
  },
  {
    title: "Digital Assets",
    description: "Managed exposure to blockchain technology and digital asset opportunities.",
    aum: "$150M",
    icon: Cpu,
    performance: "+45.2% YoY"
  }
]

export function AssetManagement() {
  return (
    <div className="container mx-auto px-4 py-24 bg-neutral-50 dark:bg-neutral-900">
      <div className="text-center mb-16">
        <h2 className="text-3xl font-bold tracking-tight">Asset Management</h2>
        <p className="mt-4 text-lg text-neutral-600 dark:text-neutral-400">
          Diversified investment solutions across multiple asset classes
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-2">
        {assetClasses.map((asset) => {
          const Icon = asset.icon
          return (
            <Card key={asset.title} className="border-none shadow-lg">
              <CardHeader>
                <div className="flex items-center justify-between mb-4">
                  <Icon className="h-8 w-8 text-neutral-600 dark:text-neutral-400" />
                  <span className="text-sm font-medium text-green-600 dark:text-green-400">
                    {asset.performance}
                  </span>
                </div>
                <CardTitle className="text-xl">{asset.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-neutral-600 dark:text-neutral-400 mb-4">
                  {asset.description}
                </p>
                <div className="text-2xl font-bold text-neutral-900 dark:text-neutral-50">
                  {asset.aum}
                </div>
                <div className="text-sm text-neutral-600 dark:text-neutral-400">
                  Assets Under Management
                </div>
              </CardContent>
            </Card>
          )
        })}
      </div>
    </div>
  )
} 